export const PHOTO_TYPES = {
  PHOTO: 'PHOTO',
  LOGO: 'LOGO',
  FOREGROUND: 'FOREGROUND',
};

export const PHOTO_UPLOAD_TYPE = {
  GREEN_SCREEN_COMPOSITE: 'GREEN_SCREEN_COMPOSITE',
  GREEN_SCREEN_ENABLED: 'GREEN_SCREEN_ENABLED',
  GREEN_SCREEN_DISABLED: 'GREEN_SCREEN_DISABLED',
  NOT_UPLOADING: 'NOT_UPLOADING',
};
